import {isObject, merge} from '@raison/toolbox';
import * as Sentry from '@sentry/react';
import {appSessionStorage} from '../../persistence';

export function sentryFeedBack(contextName: string, errorName: string, error: Record<string, unknown> | unknown) {
    const id = appSessionStorage.userId.get();
    const scope = new Sentry.Scope();
    const realObject = isObject(error) ? error : {error};
    const localObject = merge({}, realObject, {id});

    if (!errorName?.length) errorName = `Error name not set`;
    if (!contextName?.length) contextName = `Context name not set`;

    Sentry.setContext(contextName, {error, id});
    Sentry.captureException(new Error(`${errorName} ${JSON.stringify(localObject)}`), scope);
}
